<script>
/**
 * Componente de gráfico de línea en PDF Generado.
 * --------------------------------------------
 *
 * Este componente dibuja un gráfico a partir de la data recibida.
 *
 */
import { Line } from "vue-chartjs";

function getCol(matrix, col) {
  var column = [];
  for (var i = 0; i < matrix.length; i++) {
    if(matrix[i][col]!=undefined){
      column.push(matrix[i][col]);
    }
  }
  return column.reverse();
}

/**
 * Dibuja en el gráfico la unidad de medida según el tipo de sensor que sea.
 */
function getMeasurement(dataName) {
  let measurement = "";
  switch (dataName) {
    case "CO2":
      measurement = `ppm`;
      break;
    case "noise":
      measurement = `dB`;
      break;
    case "AQI":
      measurement = " ";
      break;
    default:
      measurement = "µg/m³";
      break;
  }
  return measurement;
}

export default {
  extends: Line,
  props: ["single", "data", "lines"],
  data() {
    return {
      graphs: {},
      dataset: [],
      label: [],
      name: "",
      options: {
        animation: {
          onComplete: function () {
            let c = sessionStorage.getItem("contador");
            sessionStorage.setItem("contador", parseInt(c) + 1);
          }.bind(this),
        },
        legend: {
          labels: {
            filter: function (legendItem) {
              if (legendItem.text === "") {
                return false;
              }
              return true;
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value, index, values) {
                  return value + " " + getMeasurement(this.single);
                }.bind(this),
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
      },
    };
  },
    /**
     * Obtiene un dataset por cada sensor. que se le pasa con su configuración.
     */
  async beforeMount() {
    this.graphs = this.data;
    this.dataset = await this.getDatasets(this.graphs);
    this.renderLineChart();
  },

  methods: {
    /**
     * Crea el dataset a partir del tipo de sensor que se le pase. Si se le pasa un nombre, un influxId, límites.
     */
    getDatasets() {
      let specialDS = [];

      if (this.single === "") {
        for (const el in this.graphs) {
          if (Object.hasOwnProperty.call(this.graphs, el)) {
            const element = this.graphs[el];
            if (
              element.type === "line" &&
              element.influxId !== "CO2" &&
              element.name !== "noise" &&
              element.name !== "AQI"
            ) {
              
              this.dataset.push({
                label:
                  element.name === "noise"
                    ? this.$i18n.t("map_sensors_noise")
                    : element.name,
                data: getCol(element.sensorData, 1),
                backgroundColor: "rgba(147, 189, 134, .0)",
                borderColor: this.getColorBySensor(element.influxId),
                pointBackgroundColor: this.getColorBySensor(element.influxId),
                pointRadius: 0,
                borderWidth: 0.8,
              });
              this.label = getCol(this.formatDates2(element.sensorData), 0);
            }
          }
        }
      } else {
        for (const el in this.graphs) {
          if (Object.hasOwnProperty.call(this.graphs, el)) {
            const element = this.graphs[el];
            if (element.type === "line" && element.influxId === this.single) {
              let r = this.getRandomInt();
              let g = this.getRandomInt();
              let b = this.getRandomInt();

              specialDS = [
                {
                  lineTension: 0,
                  label:
                    element.name === "noise"
                      ? this.$i18n.t("map_sensors_noise")
                      : element.name,
                  data:
                    element.name == "AQI"
                      ? getCol(element.sensorData, 1).reverse()
                      : getCol(element.sensorData, 1),
                  lineTension: 0,
                  backgroundColor: "rgba(147, 189, 134, .0)",
                  borderColor:
                    element.influxId == "noise" || element.influxId == "CO2"
                      ? element.influxId == "noise"
                        ? "#000"
                        : "#1c30e4"
                      : `rgba(113, 174, 73, 1)`,
                  pointBackgroundColor: `rgba(${r}, ${g}, ${b}, 0)`,
                  pointRadius: 0,
                  borderWidth: 1,
                },
              ];

              if (this.lines) {
                let dotted = 0;
                this.lines.forEach((line) => {
                  let dataLine = [];

                  for (let i = 0; i < element.sensorData.length; i++) {
                    dataLine.push(line.value);
                  }

                  specialDS.push({
                    label: line.name,
                    data: dataLine,
                    borderDash: [5, dotted],
                    backgroundColor: "rgba(255, 0, 0,.0)",
                    borderColor: "rgba(255, 0, 0, 1)",
                    pointBackgroundColor: "rgba(255, 0, 0, .0)",
                    pointRadius: 0,
                    borderWidth: 1,
                  });
                  dotted += 2;
                });
                this.label = getCol(this.formatDates2(element.sensorData), 0);
              } else {
                if (element.name == "AQI") {
                  this.label = getCol(
                    this.formatDates2(element.sensorData),
                    0
                  ).reverse();
                } else {
                  this.label = getCol(this.formatDates2(element.sensorData), 0);
                }
              }
            }
          }
        }
      }

      if (specialDS.length > 0) {
        return specialDS;
      }

      return this.dataset;
    },
    /**
     * Renderiza el chart pasando el labe y el dataset. También se le pasa la configuración del chart en options.
     */
    renderLineChart() {
      this.renderChart(
        {
          labels: this.label,
          datasets: this.dataset,
        },
        this.options
      );
    },
    /**
     * Retorna un número entre el 0 y el 255 para generar un número al azar entero.
     */
    getRandomInt() {
      return Math.floor(Math.random() * (255 - 5 + 1)) + 5;
    },
    /**
     * Retorna un color concreto dependiendo del sensor pasado por parámetro..
     */
    getColorBySensor(sensor) {
      let color = "";
      switch (sensor) {
        case "O3":
          color = `#808000`;
          break;
        case "SO2":
          color = `#0000FF`;
          break;
        case "NO2":
          color = `#FF0000`;
          break;
        case "PM10":
          color = `#008000`;
          break;
        case "PM2_5":
          color = `#00FF00`;
          break;

        default:
          color = `#000000`;
          break;
      }
      return color;
    },
    /**
     * Retorna la data formateada hasta segundos.
     */
    formatDates(dates) {
      let newdates = [];
      dates.forEach((element) => {
        let date = new Date(element[0]);
        let dateFormated =
          date.toISOString().split("T")[0].substring(8, 10) +
          "/" +
          date.toISOString().split("T")[0].substring(5, 7) +
          " " +
          date.toISOString().split("T")[1].substring(0, 5);
        newdates.push([dateFormated]);
      });
      return newdates;
    },
    /**
     * Retorna la data formateada hasta minutos.
     */
    formatDates2(dates) {
      let newdates = [];
      dates.forEach((element) => {
        let date = new Date(element[0]);
        let dateFormated =
          date.toISOString().split("T")[0].substring(8, 10) +
          "/" +
          date.toISOString().split("T")[0].substring(5, 7);
        newdates.push([dateFormated]);
      });
      return newdates;
    },
  },
  watch: {
    data: function () {
      this.$data._chart.destroy();
      this.renderLineChart();
    },
  },
};
</script>
